/* eslint-disable */
import { setGlobalState } from './helpers';

export const mq = (() => {
  const mql = window.matchMedia('(min-width: 1000px)');

  const init = () => {
    updateMediaQueryState();
    if(mql) {
      try {
        mql.addEventListener('change', updateMediaQueryState);
      } catch(e) {
        mql.addListener(updateMediaQueryState)
      }
    }
  }

  const updateMediaQueryState = () => {
    const currentBreakpoint = mql.matches ? 'desktop' : 'mobile';
    setGlobalState('mq', currentBreakpoint);
  }

  const isDesktop = mql.matches;
  const isMobile = !isDesktop;

  return { init, mql, isDesktop, isMobile }
})();
